import { useQuery } from "react-query";
import URL from "core/resources/urls";
import http from "infra/http";

function useGetSistemaAplicacao() {
  return useQuery(
    [URL.PLANO_OPERACIONAL.OBTER_SISTEMA_APLICACAO_DROPDOWN_ID_EXTERNO],
    async () => {
      const { data } = await http.get(URL.PLANO_OPERACIONAL.OBTER_SISTEMA_APLICACAO_DROPDOWN_ID_EXTERNO);
      return data;
    }
  );
}

export default useGetSistemaAplicacao;
